
import React, { useContext, useEffect, useState } from "react";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { ThemeContext } from "../../../context/ThemeContext";
import { Link } from "react-router-dom";

import { Col, Card, Table, Badge, ProgressBar } from "react-bootstrap";
import LearningDomainsChart from "../../components/Dashboard/LearningDomainsChart";



const PerformanceIndicator = () => {

    const { changeBackground } = useContext(ThemeContext);
    const [classificationCounts, setClassificationCounts] = useState({
      excellent: 0,
      good: 0,
      acceptable: 0,
      Weak: 0,
    });
    const [rankingData, setRankingData] = useState([]);
    const [topUniversities, setTopUniversities] = useState([]);
    const [loading, setLoading] = useState(true);
  
    const fetchRanking = async () => {
      try {
        const res = await fetch("https://plo.areez.co/api/plo/university/ranking");
        if (!res.ok) throw new Error("فشل في تحميل بيانات التصنيف");
        const data = await res.json();
        setRankingData(data.data);
      } catch (err) {
        console.error("خطأ:", err);
        setRankingData([]);
      } finally {
        setLoading(false);
      }
    };
  
    const fetchTopUniversities = async () => {
      try {
        const res = await fetch("https://plo.areez.co/api/plo/universities/top10");
        const json = await res.json();
        setTopUniversities(json.data || []);
      } catch (err) {
        console.error("خطأ في جلب بيانات أفضل البرامج:", err);
      } finally {
        setLoading(false);
      }
    };
  
    
  
  
    useEffect(() => {
      fetch("https://plo.areez.co/api/plo/all_programs/classification_counts")
        .then((response) => {
          if (!response.ok) {
            throw new Error("فشل في جلب البيانات");
          }
          return response.json();
        })
        .then((data) => {
          setClassificationCounts(data);
        })
        .catch((error) => {
          console.error("حدث خطأ:", error);
        });
  
      fetchRanking();
      fetchTopUniversities();
      changeBackground({ value: "light", label: "Light" });
    }, []);
  
    const handleCompare = (program_id) => {
      let id = program_id;
      window.location.href = `/programs/compare/${id}`;
  
    };


    return (
        <div className="row">
        <div className="col-xl-3 col-lg-6 col-sm-6">
          <Link
            to={`/programs?name=${encodeURIComponent("Excellent")}`}
            style={{ textDecoration: "none" }}
          >
            <div className="widget-stat card bg-success">
              <div className="card-body p-4">
                <div className="media pb-2">
                  <span className="mr-3">
                    <i className="fa fa-caret-up"></i>
                  </span>
                  <div className="media-body text-white">
                    <p className="mb-1">عدد البرامج الممتازة</p>
                    <h3 className="text-white">
                      {classificationCounts.excellent}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-lg-6 col-sm-6">
          <Link
            to={`/programs?name=${encodeURIComponent("Good")}`}
            style={{ textDecoration: "none" }}
          >
            <div className="widget-stat card bg-info">
              <div className="card-body p-4">
                <div className="media pb-2">
                  <span className="mr-3">
                    <i className="fa fa-minus"></i>
                  </span>
                  <div className="media-body text-white">
                    <p className="mb-1">عدد البرامج الجيدة</p>
                    <h3 className="text-white">{classificationCounts.good}</h3>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-lg-6 col-sm-6">
          <Link
            to={`/programs?name=${encodeURIComponent("Acceptable")}`}
            style={{ textDecoration: "none" }}
          >
            <div className="widget-stat card bg-secondary">
              <div className="card-body p-4">
                <div className="media pb-2">
                  <span className="mr-3">
                    <i className="fa fa-exclamation"></i>
                  </span>
                  <div className="media-body text-white">
                    <p className="mb-1">عدد البرامج مقبولة</p>
                    <h3 className="text-white">
                      {classificationCounts.acceptable}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-xl-3 col-lg-6 col-sm-6">
          <Link
            to={`/programs?name=${encodeURIComponent("Weak")}`}
            style={{ textDecoration: "none" }}
          >
            <div className="widget-stat card bg-danger">
              <div className="card-body p-4">
                <div className="media pb-2">
                  <span className="mr-3">
                    <i className="fa fa-caret-down"></i>
                  </span>
                  <div className="media-body text-white">
                    <p className="mb-1">عدد البرامج الضعيفة</p>
                    <h3 className="text-white">{classificationCounts.weak}</h3>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
  
        <div className="col-xl-6 col-xxl-12">
          <div className="card">
            <div className="card-header d-sm-flex d-block pb-0 border-0">
              <div>
                <h4 className="fs-20 text-black">مقارنة بين الجامعات</h4>
                {/* <p className="mb-0 fs-12">
                  متوسط تحقيق مجالات التعلم الرئيسية في آخر 5 سنوات
                </p> */}
              </div>
            </div>
            <div className="card-body pb-0">
              <LearningDomainsChart />
            </div>
          </div>
        </div>
  
        
    
        <Col lg={6}>
    <Card>
      <Card.Header>
        <Card.Title>أفضل 10  الجامعات</Card.Title>
      </Card.Header>
      <Card.Body>
        {loading ? (
          <p className="text-center">جاري التحميل...</p>
        ) : topUniversities.length === 0 ? (
          <p className="text-center">لا توجد بيانات.</p>
        ) : (
          <Table responsive hover className="header-border verticle-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>الجامعة</th>
                <th>التصنيف</th>
                <th></th>
                {/* <th>عمليات</th> */}
              </tr>
            </thead>
            <tbody>
              {topUniversities.map((item, index) => (
                <tr key={item.program_id}>
                  <th>{index + 1}</th>
                  <td>{item.university_name}</td>
                  <td>
                    <span
                      className={`badge badge-${
                        {
                          excellent: "success",
                          good: "info",
                          acceptable: "secondary",
                          weak: "danger",
                        }[item.classification?.toLowerCase()]
                      }`}
                    >
                      {item.classification}
                    </span>
                  </td>
                  <td>
                    <ProgressBar
                      now={item.average_pct}
                      variant="primary"
                      style={{ height: "6px" }}
                    />
                    <Badge variant="primary light" className="ml-2">
                      {item.average_pct.toFixed(2)}%
                    </Badge>
                  </td>
                  {/* <td>
                  <button
                             className="btn btn-sm btn-outline-primary"
                             style={{marginLeft:"5px"}}
                             onClick={() => handleCompare(item.program_id)}
                           >
                             تفاصيل
                           </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  </Col>
  
        
      </div>
    )
} 

export default PerformanceIndicator;
